module.exports = __webpack_public_path__ + "img/maintenance.f326a8a3.jpg";